/* eslint-disable security/detect-unsafe-regex */
export const validateEmail = (email) => {
    if (!email) return true; // Return true for invalid empty email
    
    // Email regex pattern - slightly improved from your original
    const emailPattern = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}$/;
    
    // Return true if email is invalid (matches your current logic)
    return !emailPattern.test(email);
}